import PropTypes from 'prop-types';

import ContextualMenuNavigation from 'src/_components/Navigations/ContextualMenuNavigation';
import SideMenuNavigation from 'src/_components/Navigations/SideMenuNavigation';
import VersionDropdown from 'src/_components/References/_components/VersionDropdown';

import styles from './GuideWrapper.module.scss';

const GuideWrapper = function (props) {
  const { breadcrumbs, contentStyle = '', showContextualMenu = true } = props;

  return (
    <div>
      <div className={styles.breadcrumb_wrapper} id="breadcrumb">
        <div className={styles.breadcrumbs}>{breadcrumbs}</div>
        <VersionDropdown />
      </div>
      <div className={styles.main}>
        <div className={styles.left_nav}>
          <SideMenuNavigation page={props.nav.page} subpage={props.nav.subpage} />
        </div>
        <div id="main_content" className={contentStyle ? contentStyle : styles.main_content}>
          {props.children}
        </div>
        {showContextualMenu && (
          <div className={styles.right_nav_wrapper}>
            <ContextualMenuNavigation />
          </div>
        )}
      </div>
    </div>
  );
};

GuideWrapper.propTypes = {
  breadcrumbs: PropTypes.object.isRequired,
  nav: PropTypes.shape({
    page: PropTypes.string.isRequired,
    subpage: PropTypes.string,
  }).isRequired,
  contentStyle: PropTypes.string,
  showContextualMenu: PropTypes.bool,
};

export default GuideWrapper;
